/**
 * Created by Kevin Dench on 6/28/2016.
 */
/* @ngInject */
export default function BrowseService(CacheService, BreadcrumbParserService) {
    return {
        handleDefinitionChild: function (currentDefinition, parentDefinition) {
            CacheService.storeDefinition(currentDefinition);
            CacheService.storeParentDefinition(parentDefinition);

            return {
                definition: CacheService.getDefinition(),
                parentDefinition: parentDefinition,
                definitionNameBreadcrumb: BreadcrumbParserService.getUIBreadcrumb(currentDefinition)
            };
        },
        handleDefinitionParent: function (currentDefinition, parentDefinition) {
            return {
                definition: CacheService.getParentDefinition().pop(),
                parentDefinition: CacheService.getParentDefinition()[CacheService.getParentDefinition().length - 1],
                definitionNameBreadcrumb: BreadcrumbParserService.getUIBreadcrumb(parentDefinition)
            };
        }
    };
}
